

// @mui material components
import Grid from "@mui/material/Grid";
import MDBox from "../../../../../components/MDBox";
import FormField from "../../../../../components/FormField";
import React from "react";
import MDTypography from "../../../../../components/MDTypography";
// Material Dashboard 2 PRO React components


function EditPatientForm({formData, doctors}) {

    const {formField, values, errors, touched} = formData;

    const {name, last_name, mother_last_name, email, phone, date_of_birth, comments, doctor_id} = formField;
    const {
        name: nameV,
        last_name: lastNameV,
        mother_last_name: motherLastNameV,
        email: emailV,
        phone: phoneV,
        date_of_birth: dateOfBirthV,
        comments: commentsV,
        doctor_id: doctorIdV
    } = values;

    return (
        <MDBox>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                    <FormField
                        type={last_name.type}
                        label={last_name.label}
                        name={last_name.name}
                        value={lastNameV}
                        error={errors.last_name && touched.last_name}
                        success={lastNameV && lastNameV.length > 0 && !errors.last_name}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormField
                        type={mother_last_name.type}
                        label={mother_last_name.label}
                        name={mother_last_name.name}
                        value={motherLastNameV}
                        error={errors.mother_last_name && touched.mother_last_name}
                        success={motherLastNameV && motherLastNameV.length > 0 && !errors.mother_last_name}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormField
                        type={name.type}
                        label={name.label}
                        name={name.name}
                        value={nameV}
                        error={errors.name && touched.name}
                        success={nameV && nameV.length > 0 && !errors.name}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField
                        type={email.type}
                        label={email.label}
                        name={email.name}
                        value={emailV}
                        error={errors.email && touched.email}
                        success={emailV && emailV.length > 0 && !errors.email}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField
                        type={phone.type}
                        label={phone.label}
                        name={phone.name}
                        value={phoneV}
                        error={errors.phone && touched.phone}
                        success={phoneV && phoneV.length > 0 && !errors.phone}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={date_of_birth.type}
                        label={date_of_birth.label}
                        name={date_of_birth.name}
                        value={dateOfBirthV}
                        options={date_of_birth.options}
                        error={errors.date_of_birth && touched.date_of_birth}
                        success={dateOfBirthV && dateOfBirthV.length > 0 && !errors.date_of_birth}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={doctor_id.type}
                        label={doctor_id.label}
                        name={doctor_id.name}
                        value={doctorIdV}
                        options={doctors}
                        error={errors.doctor_id && touched.doctor_id}
                        success={doctorIdV && doctorIdV.length > 0 && !errors.doctor_id}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={comments.type}
                        label={comments.label}
                        name={comments.name}
                        value={commentsV}
                        error={errors.comments && touched.comments}
                        success={commentsV && commentsV.length > 0 && !errors.comments}
                        {...comments}
                    />
                </Grid>
            </Grid>
        </MDBox>
    );
}

export default EditPatientForm;
